import * as React from 'react'

export const ChevronDown = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="15px" height="15px" viewBox="0 0 15 15" fill={props.color} {...props}>
    <path
      d="M3.135 6.158a.5.5 0 0 1 .707-.023L7.5 9.565l3.658-3.43a.5.5 0 0 1 .684.73l-4 3.75a.5.5 0 0 1-.684 0l-4-3.75a.5.5 0 0 1-.023-.707Z"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </svg>
)
